import { BadgePanel, HonestyPopover, type PanelRow } from './Popover'
import { CHIP_BASE } from './chrome'
import { t } from '@/lib/ui'

// § law-fixed badge (DESIGN-BRIEF §4): filled slate-blue chip, monospace §.
// Clicking reveals the statute citation (act + section) and the spec id —
// the trace back to law (SIM-015). Data (statute/specId) is passed by later
// WPs; with none, the popover shows the generic explanation.

interface LawBadgeProps {
  /** e.g. "Lapsilisälaki 796/1992 6 §" */
  statute?: string
  /** e.g. "rul-032" — deep-links to /spec/:id */
  specId?: string
  /** Overrides the generic explanation. */
  hint?: string
  /** Visible chip label (defaults to "§"). */
  label?: string
}

export function LawBadge({ statute, specId, hint, label }: LawBadgeProps) {
  const rows: PanelRow[] = []
  if (statute) rows.push({ label: t('honesty.popover.sourceLabel'), value: statute })

  return (
    <HonestyPopover
      triggerAriaLabel={t('honesty.law.name')}
      triggerClassName={`${CHIP_BASE} bg-law font-mono text-paper hover:opacity-80`}
      triggerLabel={<span aria-hidden="true">{label ?? t('honesty.law.label')}</span>}
    >
      <BadgePanel
        name={t('honesty.law.name')}
        hint={hint ?? t('honesty.law.hint')}
        rows={rows}
        specId={specId}
      />
    </HonestyPopover>
  )
}
